import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const EmailList = ({ emails, separator = ',' }) => {
    if (!emails) {
        return emails;
    }
    let emailsArray = Array.isArray(emails) ? emails : emails.split(separator);
    if (emailsArray.length === 0) {
        return null;
    }
    else if (emailsArray.length === 1) {
        return emailsArray[0];
    }
    return emailsArray.map((email, index) => {
        return _jsxs(React.Fragment, { children: [email, index < emailsArray.length - 1 ? _jsx("br", {}) : ''] }, index);
    });
};
export default EmailList;
